// extracted by mini-css-extract-plugin
export var table = "_xp-0";